import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const { CALL_STATE } = STATE_IDENTIFIER;

export default {
  [CALL_STATE]: IResponseState.PENDING,
};
